import axios from 'axios'
import apiURI from './Api';

export default class BrandsService {
  async getBrands(token) {
    const response = await axios({ method: 'get', url: `${apiURI}/product/category/getallbrands`, headers: { 'Authorization': 'Bearer ' + token } });
    return response.data;
  }

  async postRegisterBrands(token, descriptionBrand) {
    const bodyJson = {
      descriptionBrand,
   }

      const response = await axios({
      method: 'post', data: bodyJson,
      url: `${apiURI}/product/category/brand/register`, 
      headers: { 'Authorization': 'Bearer ' + token }
    });

    return response.data;
  }

  async postEditBrands(token, descriptionBrand, idbrand) {
    const bodyJson = {
      descriptionBrand,
      idbrand,
   }

      const response = await axios({
      method: 'post', data: bodyJson,
      url: `${apiURI}/product/category/brand/edit`, 
      headers: { 'Authorization': 'Bearer ' + token }
    });

    return response.data;
  }
    
}
